import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { IProductGroupSearchV2, ISearchResponse, ResultObjectType } from '@cbgms/api'
import { UseQueryResult, useQuery } from '@cbgms/base/http/use-query'
import { getProductGroupsOrdersSearch } from 'app/products/state/actions'
import { ProductSearchResultType, VirtualSearchResultType } from '@cbgms/components/src/product-search/types/IProductSearchResultProps'

const PRODUCT_GROUP_ORDERS_SEARCH = 'PRODUCT_GROUP_ORDERS_SEARCH'

export const emptySearch: ISearchResponse = {
  Errors: [],
  Filters: [],
  LimitedResultCount: 0,
  Results: [],
  TotalResultCount: 0
}

// eslint-disable-next-line carsys-custom/typescript-prefer-interface-extend-over-intersection
export type IProductOutput = UseQueryResult<IProductGroupSearchV2, null> & { isPartsLoading: boolean }

const NO_CACHE = 0

export const useProductQueryResultTypes = (
  enabled: (q: string) => boolean,
  query: string,
  resultTypes: ProductSearchResultType[],
  orderAccountID?: string,
  vehicleUUID?: string
): IProductOutput => {
  const dispatch = useDispatch()

  const searchTypes = useMemo(() => {
    return resultTypes.filter(r => r !== VirtualSearchResultType.CallToActionSearchParts)
  }, [resultTypes, VirtualSearchResultType])

  const queryOptions = {
    queryKey: [PRODUCT_GROUP_ORDERS_SEARCH, query, ...Object.values(resultTypes)],
    cacheTime: NO_CACHE,
    staleTime: NO_CACHE,
    enabled: enabled(query),
    // Always show fresh suggestions for the active query; avoid displaying stale
    // results (e.g. tyre suggestions) while fetching a different search term.
    keepPreviousData: false,
    queryFn: async () => {
      const { Data } = await dispatch(getProductGroupsOrdersSearch(query, searchTypes as ResultObjectType[], orderAccountID, vehicleUUID))
      return Data
    }
  }

  const searchQuery = useQuery(queryOptions)

  const result = useMemo(
    () =>
      ({
        ...searchQuery,
        isPartsLoading: searchQuery.isFetching
      } as IProductOutput),
    [searchQuery]
  )

  return result
}
